// extracted by mini-css-extract-plugin
export var footer = "_mt-5";
export var fulfillmentInput = "_mt-0";
export var shipDateInput = "_mt-1";
export var shipmentModal = "_mt-2";
export var shipmentModalContent = "_mt-3";
export var tableContainer = "_mt-4";